import { useEffect, useRef, useMemo} from 'react'
import { Body, Events, Engine, Render, Runner, Bodies, World } from 'matter-js'

import spriteblue from './../sprites/virusdead-250-min.png'
import spritegrey from './../sprites/virusunknown-250-min.png'
import spriteorange from './../sprites/virusorange-250-min.png'
import spriteorange1 from './../sprites/virusorange-250-2-min.png'
import spriteorange2 from './../sprites/virusorange-250-3-min.png'
import spriteorange3 from './../sprites/virusorange-250-4-min.png'
import spriteorange4 from './../sprites/virusorange-250-5-min.png'

import spriteyellow from './../sprites/virusyellow-250-min.png'
import spriteyellow1 from './../sprites/virusyellow-250-2-min.png'
import spriteyellow2 from './../sprites/virusyellow-250-3-min.png'
import spriteyellow3 from './../sprites/virusyellow-250-4-min.png'
import spriteyellow4 from './../sprites/virusyellow-250-5-min.png'

import spritered from './../sprites/virusred-250-min.png'
import spritered1 from './../sprites/virusred-250-2-min.png'
import spritered2 from './../sprites/virusred-250-3-min.png'
import spritered3 from './../sprites/virusred-250-4-min.png'
import spritered4 from './../sprites/virusred-250-5-min.png'

import spriteship from './../sprites/ship-min.png'
import boltorange from './../sprites/boltorange-250-min.png'
import boltred from './../sprites/boltred-250-min.png'
import boltyellow from './../sprites/boltyellow-250-min.png'


const MatterComp = (props) => {


  const sprites =  useMemo(() => {return {
    "yellow": spriteyellow,
    "yellow1": spriteyellow1,
    "yellow2": spriteyellow2,
    "yellow3": spriteyellow3,
    "yellow4": spriteyellow4,
    "red": spritered,
    "red1": spritered1,
    "red2": spritered2,
    "red3": spritered3,
    "red4": spritered4,
    "orange": spriteorange,
    "orange1": spriteorange1,
    "orange2": spriteorange2,
    "orange3": spriteorange3,
    "orange4": spriteorange4,
    "blue": spriteblue,
    "grey": spritegrey,
    "ship": spriteship,
    "boltorange": boltorange,
    "boltred": boltred,
    "boltyellow": boltyellow
  }},[])

  const {shotCount, setShotCount, timer,scores, setScores, soundOn, hit, phit, fired, rotating, changeScore,bugLevels,setBugLevels} = props

  const engineRef = useRef(Engine.create({}))
  const matterBox = useRef(false)
  const shipRef = useRef(false)
  const rotateInterval = useRef(false)
  const bugInterval = useRef(false)

  useEffect(() => {
    if (sprites) {
      Object.keys(sprites).forEach(s => {
        const newImage = new Image();
        newImage.src = sprites[s];
        window[s] = newImage;
      })
    }
  },[sprites])

  useEffect(() => {

    
    let engine = engineRef.current
    //const cw = document.body.clientWidth
    //const ch = document.body.clientHeight

    const render = Render.create({
      element: matterBox.current,
      engine: engine,
      options: {
        width: 1000,
        height: 1000,
        wireframes: false,
        background: "#2a2a2a"
      }
    })

    let circle = Bodies.circle(500, 500, 420, {render: {
      fillStyle: "none",
      lineWidth: 0,
      strokeStyle: "white"
    }
    });
    circle.label = "circle1"
    circle.isSensor = true
    Body.scale(circle, 1.5, 1 )

    let circle2 = Bodies.circle(500, 500, 320, {render: {
      fillStyle: "none",
      lineWidth: 0,
      strokeStyle: "white"
    }
    });
    circle2.label = "circle2"
    circle2.isSensor = true
    Body.scale(circle2, 1.5, 1 )


    let circle3 = Bodies.circle(500, 500, 220, {render: {
      fillStyle: "none",
      lineWidth: 0,
      strokeStyle: "white"
    }
    });
    circle3.label = "circle3"
    circle3.isSensor = true
    Body.scale(circle3, 1.5, 1 )

    World.add(engine.world, [circle])

    World.add(engine.world, [circle2])
    World.add(engine.world, [circle3])


    shipRef.current = Bodies.circle(500, 500, 50, {render: {
      fillStyle: "gray",
      lineWidth: 0,
      strokeStyle: "white",
      sprite: {  
        texture: sprites["ship"],
        xScale: 1/2,
        yScale: 1/2
      }
    }
    });

    let shipCircle = Bodies.circle(500, 500, 50, {render: {
      fillStyle: "none",
      lineWidth: 0,
      strokeStyle: "white"
    }
    });
    shipCircle.label = "shipCircle"

    shipCircle.isSensor = true
    World.add(engine.world, [shipCircle])
    let ship = shipRef.current
    ship.isSensor = true

    engine.gravity.x = 0;
    engine.gravity.y = 0;

    Body.rotate(ship, Math.PI )
    Body.scale(ship, 1.2, 0.7 )

    World.add(engine.world, [ship])
    Runner.run(engine)
    Render.run(render)

    
    
    
    
    
    



 
    return () => {
      Render.stop(render)
      World.clear(engine.world)
      Engine.clear(engine)
      render.canvas.remove()
      render.canvas = null
      render.context = null
      render.textures = {}
     
    }
  }, [sprites])


  useEffect(() => {
    let engine = engineRef.current
    let interval = setInterval(() => {
      engine.world.bodies.forEach(b => {

        if (b.position.x > 1000 || b.position.x < 0 || b.position.y > 1000 || b.position.y < 0 ) {
          if (b.label === "bolt") {
            let newScores = {...scores};
            newScores.antibioticsWasted[b.render.fillStyle] = scores.antibioticsWasted[b.render.fillStyle] + 1
            setScores(newScores)
          }
          World.remove(engine.world, b);
        }
      })
    },1000/30)
    return () => {
      clearInterval(interval)
    }
  },[setScores,scores])

  useEffect(() => {
    let engine = engineRef.current

    const startFiringBugs = () => {
      bugInterval.current = setInterval(() => {
        let bugCount = engine.world.bodies.filter(b => b.label.includes("bug")).length
        if (bugCount === 0 || (Math.random() >= 1/2 && bugCount < 9)) {
          let color = ["yellow","orange","red"][Math.floor(Math.random()*3)]
          let baseangle = Math.random() * 360
          while (!((baseangle >= 120 && baseangle <= 240) || baseangle <= 60 || baseangle >= 300)) {
            baseangle = Math.random() * 360
          }

          
            let angle = (-90 + baseangle) * Math.PI/180
            let bug = Bodies.circle(500 - Math.cos(angle) * 500,500 - Math.sin(angle)* 500, 50, {  render: {
              fillStyle: "grey",
              strokeStyle: "white",
              lineWidth: 0,
              sprite: {  
                texture: sprites["grey"],
                xScale: 1/3,
                yScale: 1/3
              }

            }});
            bug.label = "bug_" + JSON.stringify({color: color, state: 0, misses: bugLevels[color]})
            bug.friction = 0
            bug.frictionAir = 0
            bug.isSensor = true
            World.add(engine.world, [bug]);
            let force = timer <= 57 ? 0.03 + (60 - timer)/1000 : 0.03
        

            Body.applyForce(bug, {x: bug.position.x, y: bug.position.y}, {x: Math.cos(angle) * force, y:  Math.sin(angle) * force})
          }
        
      },1000)
    }

    const checkForActiveTab = () => {
      if(document.hidden) {
        clearInterval(bugInterval.current)
      }
      else {
        startFiringBugs()
      }
    }
    startFiringBugs()
    document.addEventListener('visibilitychange', checkForActiveTab)

    return () => {
      clearInterval(bugInterval.current)
      document.removeEventListener('visibilitychange', checkForActiveTab)
  }},[bugLevels,sprites,timer])

  useEffect(()=> {
    let engine = engineRef.current

    const updateBugLevels = (color) => {
      let newLevels = {...bugLevels};
      let newLevel = newLevels[color] === 4 ? 4 : newLevels[color] + 1
      newLevels[color] = newLevel
      setBugLevels(newLevels)
      engine.world.bodies.filter(b => b.label.startsWith("bug_") ).forEach(b => { 
        let bugData = JSON.parse(b.label.split("_")[1])
        if (bugData.color === color && bugData.misses < newLevel) bugData.misses = newLevel
        b.label = "bug_" + JSON.stringify(bugData)
      })
    }

    Events.on(engine, 'collisionStart', function(event) {
      event.pairs.forEach(({ bodyA, bodyB }) => {
        if (bodyA.label.startsWith("circle") && bodyB.label.startsWith("bug_")) {
          let bugData = JSON.parse(bodyB.label.split("_")[1])
          if (bugData.state === 0 && (Math.random() <= 1/3 ) ){
            bodyB.render.sprite.texture = sprites[bugData.color]

            if (bugData.misses === 4) {
              bodyB.render.sprite.texture = sprites[bugData.color + "4"]
            } else
            if (bugData.misses === 3) {
              bodyB.render.sprite.texture = sprites[bugData.color + "3"]
            } else
            if (bugData.misses === 2) {
              bodyB.render.sprite.texture = sprites[bugData.color + "2"]
            } else
            if (bugData.misses === 1) {
              bodyB.render.sprite.texture = sprites[bugData.color + "1"]
            } else {
              bodyB.render.sprite.texture = sprites[bugData.color]
            }

            bugData.state = 1
            bodyB.label = "bug_" + JSON.stringify(bugData)
          }
        } else 
        if (bodyA.label === "shipCircle" && bodyB.label.startsWith("bug_")){
          let bugData = JSON.parse(bodyB.label.split("_")[1])
          if (bugData.state === 3) {
            changeScore(200)
          } else if (bodyB.render.sprite.texture === spritegrey) {

            let newScores = {...scores};
            newScores.unidentifiedBugs.ignored = newScores.unidentifiedBugs.ignored + 1
            setScores(newScores)
            
          } else {
            if (soundOn) phit() 
            changeScore(-100)
          }
          World.remove(engine.world, bodyB);
        } else
        if (bodyA.label.startsWith("bug_") && bodyB.label === "bolt") {
          let bugData = JSON.parse(bodyA.label.split("_")[1])
          if (bugData.state !== 3) {
            World.remove(engine.world, bodyB);
          }
          if (bugData.state === 3) {
          } else
          if (bugData.color === String(bodyB.render.fillStyle) && bodyA.render.sprite.texture === spritegrey) {

            let newScores = {...scores};
            newScores.unidentifiedBugs.hit = newScores.unidentifiedBugs.hit + 1
            setScores(newScores)
           
            bugData.state = 3
            bodyA.label = "bug_" + JSON.stringify(bugData)
          } else
          if (bugData.color === String(bodyB.render.fillStyle) && bugData.misses > 0) {
            bugData.misses -= 1
            bodyA.label = "bug_" + JSON.stringify(bugData)
          } else
          if (bugData.color === String(bodyB.render.fillStyle)) {
            bugData.state = 3
            bodyA.label = "bug_" + JSON.stringify(bugData)
            if (soundOn)  hit()
          } else
          if (!bugData.misses || bugData.misses === 0) {
            
              let newScores = {...scores};
              newScores.antibioticsWasted[bodyB.render.fillStyle] = scores.antibioticsWasted[bodyB.render.fillStyle] + 1
              setScores(newScores)
           
              bugData.misses = 1
              updateBugLevels(bugData.color)
          
              bugData.state = 1
              bodyA.label = "bug_" + JSON.stringify(bugData)
          } else if (bugData.misses < 4) {
            

              let newScores = {...scores};
              newScores.antibioticsWasted[bodyB.render.fillStyle] = newScores.antibioticsWasted[bodyB.render.fillStyle] + 1
              setScores(newScores)
              bugData.misses += 1
              updateBugLevels(bugData.color)

           
              bugData.state = 1
              bodyA.label = "bug_" + JSON.stringify(bugData)
          } else {
            bugData.misses = 4
            bugData.state = 1
            bodyA.label = "bug_" + JSON.stringify(bugData)
        }
          
          if (bugData.state === 3) {

            bodyA.render.sprite.texture = sprites["blue"]
            bodyA.render.sprite.xScale = 1/8
            bodyA.render.sprite.yScale = 1/8
            Body.setVelocity(bodyA, {x: bodyA.velocity.x * 8,
              y: bodyA.velocity.y * 8
              
            })
          } else
          if (bugData.misses === 4) {
            bodyA.render.sprite.texture = sprites[bugData.color + "4"]
          } else
          if (bugData.misses === 3) {
            bodyA.render.sprite.texture = sprites[bugData.color + "3"]
          } else
          if (bugData.misses === 2) {
            bodyA.render.sprite.texture = sprites[bugData.color + "2"]
          } else
          if (bugData.misses === 1) {
            bodyA.render.sprite.texture = sprites[bugData.color + "1"]
          } else {
            bodyA.render.sprite.texture = sprites[bugData.color]
          }


        
      }
     });
    })
    return () => Events.off(engine, 'collisionStart')
  },[timer,changeScore,hit,phit,sprites,bugLevels,setBugLevels,soundOn,setScores,scores])


  useEffect(()=> {
    let engine = engineRef.current
    let ship = shipRef.current

    if (fired) {
      let newShotCount = {...shotCount}
      newShotCount[fired] = newShotCount[fired] += 1
      setShotCount(newShotCount)
      let bolt = Bodies.circle(500 - Math.cos(ship.angle) * 10 * 3/5, 500 - Math.sin(ship.angle) * 10 * 3/5, 5, { inertia: Infinity, render: {
        fillStyle: fired,
        strokeStyle: "white",
        lineWidth: 0,
        sprite: {  
          texture: sprites["bolt" + fired],
          xScale: 1/4,
          yScale: 1/4
        }
      } });
      bolt.label = "bolt"
      bolt.friction = 0
      bolt.frictionAir = 0
      Body.rotate(bolt, ship.angle)
      Body.applyForce(bolt, {x: bolt.position.x, y: bolt.position.y}, {x: -Math.cos(ship.angle) * 0.0025, y: -Math.sin(ship.angle) * 0.0025})
      World.add(engine.world, [bolt]);
    }

    if (rotating) {
      rotateInterval.current = setInterval(()=> {
        Body.rotate(ship, rotating * Math.PI / 22.5)
        
      },1000/30)
    }

    return () => {
      clearInterval(rotateInterval.current)
    }
  },[fired,rotating, sprites,setShotCount])



 
  return (
    <>
    <div id="matterBox" ref={matterBox}  />
    </>
  )
}

export default MatterComp